import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { AddAthletePage } from "./add-athlete";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: '', component: AddAthletePage }
  ];
@NgModule({
    declarations: [
      AddAthletePage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        IonicModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        FormsModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
      AddAthletePage
    ]
  })
  export class AddAthleteModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }